import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import profilePic from '../assets/ChessDirect/profilepic.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';

const Contact = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="max-w-2xl mx-auto px-4 text-center"
    >
      {/* Home Button */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="pt-8 pb-16"
      >
        <Link 
          to="/" 
          className="inline-block bg-gray-800 border border-gray-600 rounded-xl px-6 py-3 text-gray-300 hover:text-gray-100 hover:border-gray-500 transition-all duration-200 font-medium"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          <span style={{ marginLeft: '8px' }}>Back to TrendingChess.com</span>
        </Link>
      </motion.div>
      <div className="border-t border-gray-700 pt-12">
          <ContactForm />
        </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="mt-16 pt-12 border-t border-gray-700"
      >
        <h1 className="text-4xl font-bold text-gray-100 mb-8">
          Contact
        </h1>
        
        <div className="text-gray-300 text-lg leading-relaxed mb-12">
          <p className="mb-4">
            <a
              href="https://twitter.com/TrendingChess"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors duration-200"
            >
              <FontAwesomeIcon icon={faTwitter} className="mr-2" />
              @TrendingChess
            </a>
          </p>
        </div>

        
      </motion.div>
    </motion.div>
  );
};

export default Contact;